//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import oaForm from './oa-form';
export default {
  name: 'CrmebOaEntIndex',
  components: {
    oaForm: oaForm
  },
  props: {
    // 弹窗样式
    fromData: {
      type: Object,
      default: function _default() {}
    },
    // 表单内容
    formConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 表单绑定值
    formDataInit: {
      type: Object,
      default: function _default() {}
    },
    // 表单规则
    formRules: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      show: false,
      loading: '',
      form: this.formDataInit
    };
  },
  methods: {
    openBox: function openBox() {
      this.show = true;
    },
    submitOk: function submitOk(form) {
      this.$emit('submit', form, this.fromData.type);
    },
    selectChange: function selectChange(val) {
      this.$emit('getRankList', val);
    },
    submit: function submit() {
      this.$refs.oaForm.submit();
    },
    handleClose: function handleClose() {
      this.show = false;
      this.$refs.oaForm.closeFn();
    }
  }
};